"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _TextInput = _interopRequireDefault(require("../TextInput/TextInput"));
var _excluded = ["name"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/*:: import { type TextInputType } from '../TextInput/TextInput';*/
/*:: export type EmailInputType = TextInputType;*/
function EmailInput(_ref /*:: */) {
  var name = _ref /*:: */.name,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/React.createElement(_TextInput.default, (0, _extends2.default)({
    "data-testid": name || 'email-input',
    name: name
  }, props));
}
EmailInput.displayName = 'EmailInput';
EmailInput.defaultProps = {
  inputMode: 'email',
  type: 'email'
};
var _default = exports.default = EmailInput;
//# sourceMappingURL=EmailInput.js.map